// src/pages/expense/cafe/greenDraftConfig.js
// ✅ 전 사업 확산 [5] — 카페인 그린점의 businessConfig. 가산/독산/금나래와 동일한
// 패턴. 템플릿 17종은 DocumentTypeSelector.jsx의 "expense_draft-CAFE_INN_그린"
// 목록(3개 지점 템플릿의 합집합)과 expenseTemplates.js의 green_* 정의를 재사용.
//
// ⚠️ 그린점은 DB 실측 결과 CafeGreenExpense 레코드가 0건(신규 지점, 아직 실사용
// 없음) — 아래 기본값은 실측 근거가 아니라 다른 3개 지점에서 이미 확인된 "회계
// 분류는 지점과 무관하게 동일하다"는 원칙(포스임대료=사무관리비, 사회보험료=
// 연금부담금 등 회사 공통 계정과목 규칙)을 그대로 적용한 것 — 실사용 데이터가
// 쌓이면 재검증 필요.
import { makeExpenseDraftConfig } from "../_shared/expenseDraftConfig";
import VendorPanel from "../_shared/VendorPanel";
import ExpenseItemPanel from "../_shared/ExpenseItemPanel";
import SalaryPanel from "./SalaryPanel";

// ── 17종 — Intl.Collator("ko") 정렬 검증 완료(DocumentTypeSelector.jsx와 동일 순서) ──
const TEMPLATES = [
  { code: "green_gas", label: "가스" },
  { code: "green_maintenance", label: "관리비" },
  { code: "green_payroll", label: "급여지급" },
  { code: "green_holiday_gift", label: "명절격려품" },
  { code: "green_vat", label: "부가세" },
  { code: "green_social_insurance", label: "사회보험료" },
  { code: "green_goods", label: "상품구매" },
  { code: "green_supplies", label: "소모품구매" },
  { code: "green_water", label: "수도" },
  { code: "green_credit_card", label: "신용카드결제" },
  { code: "green_withholding_tax", label: "원천세" },
  { code: "green_hygiene_edu", label: "위생교육" },
  { code: "green_internet", label: "인터넷·전화요금" },
  { code: "green_vending_terminal", label: "자판기단말기" },
  { code: "green_ingredient", label: "재료구매" },
  { code: "green_electric", label: "전기" },
  { code: "green_pos_rental", label: "포스임대료" },
];

// ⚠️ 실사용 데이터 0건 — 다른 3개 지점의 동일 항목에서 확인된 회계 분류를
// 그대로 승계(임시안). item_name은 매번 달라지는 구체 품목/업체는 비워둔다.
const CATEGORY_ITEM_FIELD_DEFAULTS = {
  green_ingredient: { category_name: "그린점 재료비", item_name: "", field_name: "구입" },
  green_goods: { category_name: "상품매입비", item_name: "", field_name: "구입" },
  green_pos_rental: { category_name: "사무관리비", item_name: "포스 임대료", field_name: "납부" },
  green_internet: { category_name: "공공운영비", item_name: "인터넷 및 전화 요금", field_name: "납부" },
  green_credit_card: { category_name: "(정산 용도)수수료 합계", item_name: "(정산 용도)수수료 합계", field_name: "정산" },
  green_payroll: { category_name: "급여", item_name: "카페인 그린점 급여", field_name: "지급" },
  green_social_insurance: { category_name: "연금부담금 등", item_name: "사회보험료", field_name: "납부" },
  green_electric: { category_name: "공공운영비", item_name: "전기요금(전기료)", field_name: "납부" },
  green_gas: { category_name: "공공운영비", item_name: "가스요금", field_name: "납부" },
  green_withholding_tax: { category_name: "예수금", item_name: "원천세", field_name: "납부" },
  green_hygiene_edu: { category_name: "교육훈련비", item_name: "휴게음식점 위생교육", field_name: "납부" },
  green_vending_terminal: { category_name: "사무관리비", item_name: "자판기용 단말기 이용료", field_name: "납부" },
  green_maintenance: { category_name: "사무관리비", item_name: "그린점 관리비", field_name: "납부" },
};

const SALARY_PANEL_TEMPLATES = ["green_payroll"];
const GENERIC_TABLE_PANEL_TEMPLATES = [
  "green_pos_rental", "green_credit_card", "green_social_insurance",
  "green_holiday_gift", "green_withholding_tax", "green_vending_terminal",
];

const greenDraftConfig = makeExpenseDraftConfig({
  namespace: "cafe-green-draft",
  category: "CAFE_INN_그린",
  businessLabel: "카페인 그린점",
  // ✅ (구) 페이지가 실제로 쓰는 CafeGreenExpense.draft_no 접두어와 정확히 일치
  // (views_api.py 코드 확인 — "CAFE_INN OO점지출" 패턴이 아니라
  // "금천일자리(주)카페그린지출"이므로 이름만으로 추측하지 않고 코드값 그대로 사용).
  draftNoPrefix: "금천일자리(주)카페그린지출",
  dataApiBase: "/expense/cafe/green/",
  combinedCreateApi: "/expense/cafe/green/draft/",
  newRoutePath: "/expense/cafe/green/draft/new",
  listRoutePath: "/expense/cafe/green/draft/list",
  previewRoutePath: "/expense/cafe/green/draft/preview",
  templates: TEMPLATES,
  categoryItemFieldDefaults: CATEGORY_ITEM_FIELD_DEFAULTS,
  itemPanelTemplates: [],
  salaryPanelTemplates: SALARY_PANEL_TEMPLATES,
  genericTablePanelTemplates: GENERIC_TABLE_PANEL_TEMPLATES,
  VendorPanel,
  ExpenseItemPanel,
  SalaryPanel,
});

export default greenDraftConfig;
